import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Cell, Grid, Row, ResponsiveTableRow, H5, Subheading } from '@fs/zion-ui'
import { useRouteMatch } from '@fs/zion-router'
import { DmcResponsiveTable } from '../../common/DmcResponsiveTable'
import { timestampToDateString } from '../../../util/DateUtil'
import { RawData } from '../../common/RawData'
import { isNullOrUndefinedOrEmpty } from '../../../util/Utils'
import { deleteLastPathElement } from '../../../util/UrlUtil'
import DmcPaginator from '../../common/DmcPaginator'
import TopOperations from './TopOperations'
import TableOperations from './TableOperations'
import TreeCategories from './compactMessagesList/TreeCategories'

export default function MessagesListTable({ queueState, queueActions, queueCachesState }) {
  const { t } = useTranslation()
  const match = useRouteMatch()

  return (
    <Grid>
      {/* Row */}
      <Cell columns={7}>
        <H5 supplementary>
          <Row alignY="middle">
            <span>{queueState.queueName}</span>
            <Button to={deleteLastPathElement(match.url)}>{t('queues.backToQueueList', 'Back to Queue List')}</Button>
          </Row>
          <Subheading>{`${queueState.queueType} (${queueState.queueContents.length} ${t('queues.from', 'from')} ${
            queueState.queueTotal
          })`}</Subheading>
        </H5>
      </Cell>
      <Cell columns={5}>
        <TopOperations
          queueState={queueState}
          queueActions={queueActions}
          disabled={isNullOrUndefinedOrEmpty(queueState.selectedCheckboxes)}
        />
      </Cell>
      <TreeCategories setQueueState={queueActions.setQueueState} />
      <Cell columns={12}>
        <DmcPaginator
          index={queueState.queuePageIndex}
          setIndex={queueActions.setQueuePageIndex}
          hideResultsPerPage
          length={queueState.queueTotal}
          topAndBottom
        >
          <RawData state={queueState} testId="queueState" />
          <DmcResponsiveTable
            totalColumnCount={3}
            atSizeColumns={{
              default: {
                labels: [t('created', 'Created'), t('messages.message', 'Message'), t('operations', 'Operations')],
                columnWidths: [2, 7, 3],
              },
            }}
            separator={<br />}
          >
            {queueState.queueContents.map((message) => {
              return (
                <ResponsiveTableRow
                  key={message.id}
                  value={message.id}
                  column1={timestampToDateString({
                    timestamp: message.inQueueSince,
                    withTime: true,
                    timestampIsSeconds: true,
                  })}
                  column2={queueState.summaryComponent(message, queueCachesState)}
                  column3={<TableOperations message={message} queueState={queueState} queueActions={queueActions} />}
                />
              )
            })}
          </DmcResponsiveTable>
        </DmcPaginator>
      </Cell>
    </Grid>
  )
}
